
import { Card } from "@/components/ui/card";
import HeroSection from "@/components/BiblicalDefense/HeroSection";
import QuestionForm from "@/components/BiblicalDefense/QuestionForm";
import { useBiblicalDefense } from "@/components/BiblicalDefense/useBiblicalDefense";
import ResponseDisplay from "@/components/BiblicalDefense/ResponseDisplay";
import SampleQuestions from "@/components/BiblicalDefense/SampleQuestions";
import HeavenlyLoader from "@/components/HeavenlyLoader";
import { useEffect } from "react";
import { useScrollToNewContent } from "@/hooks/useScrollToNewContent";
import ErrorDisplay from "@/components/BiblicalDefense/ErrorDisplay";

// Sample questions that users commonly ask
const sampleQuestions = ["How can I reconcile God's sovereignty with human free will?", "Why does God allow suffering in the world?", "What does the Bible say about predestination?", "Is Jesus truly God or just a prophet?", "How can the Trinity be explained biblically?", "What happens after death according to the Bible?"];

const BiblicalDefenseTool = () => {
  const {
    question,
    setQuestion,
    isLoading,
    isSaving,
    response,
    error,
    relatedQuestions,
    handleSubmit,
    handleSampleQuestion,
    saveResponse,
    shareViaEmail,
    shareViaSMS,
    shareToFacebook
  } = useBiblicalDefense();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, []);

  // Use hook to scroll to response when it's generated
  const responseRef = useScrollToNewContent(response, {
    behavior: "smooth",
    delay: 300,
    condition: !isLoading && !!response,
    offset: 100
  });

  return <div className="max-w-6xl mx-auto">
      {/* Update the hero section title */}
      <div className="flex items-center gap-3 mb-6">
      </div>

      {/* Hero Section */}
      <HeroSection />

      {/* Sample Questions - Moved above the Question Form */}
      <SampleQuestions sampleQuestions={sampleQuestions} handleSampleQuestion={handleSampleQuestion} />

      {/* Question Form */}
      <QuestionForm question={question} setQuestion={setQuestion} handleSubmit={handleSubmit} isLoading={isLoading} />

      {/* Loading State */}
      {isLoading && <HeavenlyLoader message="Searching the Scriptures for divine wisdom..." />}

      {/* Error Display */}
      {error && <Card className="border-red-300 bg-red-50 p-4 mb-6">
          <p className="text-red-800">{error}</p>
        </Card>}

      {/* Response Display */}
      {response && !isLoading && (
        <div ref={responseRef}>
          <ResponseDisplay 
            response={response} 
            isSaving={isSaving}
            onSave={saveResponse}
            onShareEmail={shareViaEmail}
            onShareSMS={shareViaSMS}
            onShareFacebook={shareToFacebook}
          />
        </div>
      )}
    </div>;
};

export default BiblicalDefenseTool;
